export default __webpack_public_path__ + "static/media/base.2be2530f.png";